import getAfsLabelsCount from "./getAfsLabelsCount";
import getDtcLabelsCount from "./getDtcLabelsCount";

const getDtcAndAfsLabelsCountString = savedItemProducts => {
  const afsLabeldCount = getAfsLabelsCount(savedItemProducts);
  const dtcLabelsCount = getDtcLabelsCount(savedItemProducts);

  return `dtc:${dtcLabelsCount}~afs:${afsLabeldCount}`;
};

export default getDtcAndAfsLabelsCountString;
